import { ClaimDocumentsGetUseCase } from '../../../application';

export default class ClaimDocumentsGetService {
    constructor() {}

    async execute(event) {
        const request = await ClaimDocumentsGetUseCase(event);

        return request;
    }
}
